import React from 'react';
import './Skeleton.css';

const Skeleton = ({ width = '100%', height = '300px', className = '', style = {} }) => {
  return (
    <div 
      className={`skeleton rounded ${className}`}
      style={{ 
        width, 
        height,
        ...style 
      }}
    />
  );
};

export default Skeleton;